<template>
    <div class="public-class">
        <hk-header></hk-header>
        <div class="public-class-container">
            <hk-breadcrumb :links="links"></hk-breadcrumb>
            <div class="public-class-content flex flex-vertical-start flex-between">
                <div class="public-class-container-left">
                    <hk-choose-condition
                        class="choose-item"
                        @initCondition="initCondition"
                        @changeSubject="changeSubject"
                        @changeGrade="changeGrade"
                    ></hk-choose-condition>
                    <ul
                        v-if="openList.length > 0"
                        class="class-list flex flex-vertical-center flex-start"
                    >
                        <li v-for="course in openList" :key="course.id" class="class-list-item">
                            <c-course-card
                                :name="course.name"
                                :tags="[course.subject_name, course.grade_name]"
                                :play-count="course.views"
                                :avatar="course.avatar || defaultImg"
                                :course-time="course.show_time_str"
                                :username="course.teacher_name"
                                :price="course.price || 0"
                                :free="course.free"
                                :bought="course.bought"
                                :audition="false"
                                :play-count-in-center="false"
                                :state="course.status"
                                @click.native="toCourseDetail(course)"
                            ></c-course-card>
                        </li>
                    </ul>
                    <div v-else class="no-course flex flex-column flex-center flex-vertical-center">
                        <img src="@images/base/no-lesson.png" alt="" class="no-course-img" />
                        <p class="no-course-text">暂时没有公开课哦~</p>
                    </div>
                    <hk-pagination
                        v-if="openList.length !== 0"
                        :total="openListTotal"
                        @currentChange="currentChange"
                    ></hk-pagination>
                </div>
                <div class="public-class-container-right">
                    <hk-news></hk-news>
                </div>
            </div>
        </div>
        <hk-footer theme="dark"></hk-footer>
    </div>
</template>

<script>
import HkHeader from '@components/HkHeader.vue';
import HkFooter from '@components/HkFooter';
import HkBreadcrumb from '@components/HkBreadcrumb.vue';
import HkChooseCondition from '@components/HkChooseCondition.vue';
import CCourseCard from '@components/CCourseCard.vue';
import HkPagination from '@components/HkPagination.vue';
import HkNews from '@/components/HkNews.vue';
import { mapGetters } from 'vuex';
import defaultImg from '@images/base/header-exam.png';
export default {
    components: {
        HkHeader,
        HkFooter,
        HkBreadcrumb,
        HkChooseCondition,
        CCourseCard,
        HkPagination,
        HkNews
    },
    data() {
        return {
            links: [{ title: '公开课列表' }],
            defaultImg
        };
    },
    computed: {
        ...mapGetters(['openList', 'openListTotal'])
    },
    created() {},
    methods: {
        recordReplay(id) {
            // console.log(this)
            this.$trackEvent('视频回放', '进入视频回放', id);
        },
        toCourseDetail({ id }) {
            this.recordReplay(id);
            this.$router.push({
                name: 'PlaybackPlayer',
                query: {
                    id: id
                }
            });
        },
        initCondition(val) {
            const { subject_id, grade } = val;
            this.$store.commit('SET_SUBJECT', subject_id);
            this.$store.commit('SET_GRADE', grade);
            this.$store.dispatch('getOpenList');
        },
        changeSubject(val) {
            this.$store.commit('SET_SUBJECT', val);
            this.$store.dispatch('getOpenList');
        },
        changeGrade(val) {
            this.$store.commit('SET_GRADE', val);
            this.$store.dispatch('getOpenList');
        },
        currentChange(val) {
            this.$store.commit('SET_PAGE', val);
            this.$store.dispatch('getOpenList');
        }
    }
};
</script>
<style lang="scss" scoped>
.public-class {
    padding-top: 83px;
    background: #f7f6f6;
    &-container {
        width: 1200px;
        min-height: calc(100vh - 203px);
        margin: 0 auto;
        &-content {
            width: 1200px;
        }
        &-left {
            width: 100%;
            padding-bottom: 50px;
        }
        .class-list {
            margin-top: 30px;
            flex-wrap: wrap;
            &-item {
                width: 290px;
                margin-bottom: 20px;
                margin-left: 10px;
            }
            margin-left: -10px;
        }
    }
    .no-course {
        margin-top: 100px;
        &-text {
            font-size: 14px;
            color: #888;
        }
    }
}
</style>
